import PageTitle from '../../../components/page-title'
import { Button } from '../../../components/button'
import { useAuth } from '../../../contexts/auth'
import Hero from '../../../components/hero'
import { VIEWS } from '../../auth/modals'

export default function HeroSection({ onGetStartedClick }) {
  const [{ isAuthenticated }, { setAuthModal }] = useAuth()

  return (
    <div className='heroContainer'>
      <Hero desktopImageSrc='/images/heroes/verify.jpg' opacity={1}>
        <div className='titleContainer flex flexDirectionColumn alignCenter'>
          <PageTitle>
            Shop confidently.
            <br />
            Deal with real, verified people.
          </PageTitle>
          <Button className='getStarted' onClick={onGetStartedClick}>
            Get Started
          </Button>
          {!isAuthenticated && (
            <p>
              Don’t have an account?{' '}
              <button
                className='flatBtn signUp'
                onClick={() => setAuthModal({ open: true, view: VIEWS.Register })}
              >
                Sign up.
              </button>
            </p>
          )}
        </div>
      </Hero>

      <style jsx>{`
        .heroContainer {
          :global(.hero) {
            padding: 14.7rem 0 0;
          }
        }

        .titleContainer {
          margin: 0 auto;
          padding: 0 1.2rem;

          :global(.pageTitle) {
            text-align: center;
          }

          :global(.getStarted) {
            margin: 1.8rem 0 1.5rem;
          }

          p {
            font-size: 1.8rem;
          }

          .signUp {
            color: var(--primary-color);
          }
        }

        @media (max-width: 1024px) {
          .heroContainer {
            :global(.hero) {
              padding: 2.7rem 0 0;
            }
          }

          .titleContainer {
            :global(.getStarted) {
              margin: 1.8rem 0 1rem;
            }

            p {
              font-size: 1.4rem;
            }
          }
        }
      `}</style>
    </div>
  )
}
